export default function Template (props) {

    return (
        <svg className={props.className} style={{...props.style, ...{fill: 'transparent', stroke: 'currentColor'}}} fill={'transparent'} xmlns="http://www.w3.org/2000/svg" viewBox="-3 -3 32 30" strokeWidth={3}>
            <path d="M 0 13 Q 0 12 1 12 L 11 12 Q 12 12 12 13 L 12 23 Q 12 24 11 24 L 1 24 Q 0 24 0 23 L 0 13 M 16 1 Q 16 0 17 0 L 25 0 Q 26 0 26 1 L 26 12 Q 26 13 25 13 L 17 13 Q 16 13 16 12 L 16 1 M 16 18 Q 16 17 17 17 L 25 17 Q 26 17 26 18 L 26 23 Q 26 24 25 24 L 17 24 Q 16 24 16 23 L 16 18 M 0 7 Q 0 8 1 8 L 11 8 Q 12 8 12 7 L 12 1 Q 12 0 11 0 L 1 0 Q 0 0 0 1 L 0 7"/>
        </svg>
    )

}